"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyReportTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const routes_1 = require("../../../../util/routes");
const common_styled_components_1 = require("../../../common-styled-components");
const compliance_1 = require("../../../../util/compliance/compliance");
const theme_1 = require("../../../../theme");
const amountUtils_1 = require("../../../../util/amountUtils");
const timeUtils_1 = require("../../../../util/timeUtils");
const ExportCsvButton_1 = require("../ExportCsvButton");
const getAdditionalInfoColumn = (infoName) => {
    switch (infoName) {
        case "companyName":
            return {
                key: infoName,
                label: "Company",
            };
        case "poolName":
            return {
                key: infoName,
                label: "Pool",
            };
        case "shipName":
            return {
                key: infoName,
                label: "Ship",
            };
    }
};
const monthlyReportTableColumns = (additionalInfo) => (additionalInfo ? additionalInfo.map(getAdditionalInfoColumn) : []).concat([
    {
        key: "date",
        label: "Month",
    },
    {
        key: "pool_id",
        label: "Pool",
    },
    {
        key: "intensity",
        label: "Intensity (gCO₂e/MJ)",
    },
    {
        key: "balance",
        label: "+/- (tCO₂e)",
    },
]);
const CellContent = ({ monthlyReport, contentKey, compliance, }) => {
    switch (contentKey) {
        case "date":
            const link = `${routes_1.routeNames.admin}/${routes_1.routeNames.monthlyReportAdmin}/${monthlyReport.company_id}`;
            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.StrippedLink, { to: link, style: { color: theme_1.theme.colors.blue }, children: (0, timeUtils_1.formatYearMonth)(new Date(monthlyReport.year, monthlyReport.month - 1, 1)) }));
        case "intensity":
            if (monthlyReport.intensity) {
                return ((0, jsx_runtime_1.jsxs)("div", { style: { color: compliance_1.complianceOptions[compliance].color }, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.ComplianceIcon, { src: compliance_1.complianceOptions[compliance].icon }), (0, amountUtils_1.formatNumber)(monthlyReport.intensity.adjusted_intensity_gCO2e_per_MJ, 2)] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("div", {});
            }
        case "balance":
            if (monthlyReport.intensity) {
                return ((0, jsx_runtime_1.jsxs)("div", { style: { color: compliance_1.complianceOptions[compliance].color }, children: [monthlyReport.intensity.adjusted_emission_balance_ton > 0
                            ? "+"
                            : "", (0, amountUtils_1.formatNumber)(monthlyReport.intensity.adjusted_emission_balance_ton, 2)] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("div", {});
            }
        case "additionalInfo":
            return (0, jsx_runtime_1.jsx)("div", {});
        case "poolName":
        case "companyName":
        case "shipName":
            return (0, jsx_runtime_1.jsx)("div", { children: monthlyReport.additionalInfo?.[contentKey] });
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: monthlyReport[contentKey] });
    }
};
const MonthlyReportTable = ({ monthlyReports, complianceYear, metadata, showAdditionalInfo, }) => {
    const columns = monthlyReportTableColumns(showAdditionalInfo);
    const csvColumns = columns.map((column) => ({
        header: column.label,
        getValue: (monthlyReport) => {
            switch (column.key) {
                case "date":
                    return (0, timeUtils_1.formatYearMonth)(new Date(monthlyReport.year, monthlyReport.month - 1, 1));
                case "intensity":
                    return monthlyReport.intensity
                        ? (0, amountUtils_1.formatNumber)(monthlyReport.intensity.adjusted_intensity_gCO2e_per_MJ, 2) ?? ""
                        : "";
                case "balance":
                    return monthlyReport.intensity
                        ? `${monthlyReport.intensity.adjusted_emission_balance_ton > 0
                            ? "+"
                            : ""}${(0, amountUtils_1.formatNumber)(monthlyReport.intensity.adjusted_emission_balance_ton, 2) ?? ""}`
                        : "";
                case "poolName":
                case "companyName":
                case "shipName":
                    return monthlyReport.additionalInfo?.[column.key] ?? "";
                default: {
                    const value = monthlyReport[String(column.key)];
                    return typeof value === "string" || typeof value === "number"
                        ? value
                        : "";
                }
            }
        },
    }));
    return (metadata && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Row, { children: (0, jsx_runtime_1.jsx)(ExportCsvButton_1.ExportCsvButton, { rows: monthlyReports, columns: csvColumns, tableName: "monthly-reports" }) }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TH, { children: c.label }, c.key))) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: monthlyReports.map((monthlyReport) => {
                            const compliance = monthlyReport.intensity &&
                                (0, compliance_1.getCompliance)(monthlyReport.intensity.adjusted_emission_balance_ton);
                            return ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: columns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, monthlyReport: monthlyReport, compliance: compliance }) }, c.key))) }, `${monthlyReport.company_id} ${monthlyReport.pool_id} ${monthlyReport.year} ${monthlyReport.month}`));
                        }) })] })] })));
};
exports.MonthlyReportTable = MonthlyReportTable;
